// extracted by mini-css-extract-plugin
export default {"box":"AppointmentMessagePreview_box__YYfXQ","body":"AppointmentMessagePreview_body__NWcil"};